"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uid = require("../utils/uid");

var _styles = require("../styles");

var _errors = require("../utils/errors");

var _proptypes = require("../utils/proptypes");

var _document2 = require("../utils/dom/document");

var _types = require("../Datum/types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Form =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Form, _Component);

  function Form(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleReset = _this.handleReset.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.locked = false;
    _this.id = "form_" + (0, _uid.getUidStr)();
    return _this;
  }

  var _proto = Form.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setStatus();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.setStatus();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.datum.formUnmount = true;
  };

  _proto.setStatus = function setStatus() {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        pending = _this$props.pending,
        setFormStatus = _this$props.setFormStatus;
    if (!setFormStatus) return;
    var status = disabled === true ? 'disabled' : '';
    if (pending === true) status = 'pending';
    setFormStatus(status);
  };

  _proto.bindElement = function bindElement(el) {
    this.element = el;
  };

  _proto.handleSubmit = function handleSubmit(e) {
    var _this2 = this;

    e.preventDefault();
    if (e.target.getAttribute('id') !== this.id) return;
    if (this.validating || this.locked) return;
    this.validating = true; // prevent duplicate submit

    this.locked = true;
    setTimeout(function () {
      _this2.locked = false;
    }, this.props.throttle);
    var _this$props2 = this.props,
        datum = _this$props2.datum,
        onError = _this$props2.onError,
        onSubmit = _this$props2.onSubmit,
        scrollToError = _this$props2.scrollToError;
    var _document = document,
        activeElement = _document.activeElement;
    if (activeElement) activeElement.blur();
    setTimeout(function () {
      datum.validate(_types.IGNORE_BIND).then(function () {
        _this2.validating = false;
        if (onSubmit) onSubmit(datum.getValue());
        if (activeElement) activeElement.focus();
      }).catch(function (err) {
        _this2.validating = false;

        if (scrollToError !== false) {
          var el = _this2.element.querySelector("." + (0, _styles.formClass)('invalid'));

          if (el) {
            el.scrollIntoView();
            if (el.focus) el.focus();
          }

          if (typeof scrollToError === 'number' && scrollToError !== 0) {
            _document2.docScroll.top -= scrollToError;
          }
        }

        if (onError) onError(err);
        if (!(err instanceof _errors.FormError)) throw err;
      });
    }, 10);
  };

  _proto.handleReset = function handleReset() {
    var _this$props3 = this.props,
        datum = _this$props3.datum,
        onReset = _this$props3.onReset;
    datum.reset();
    if (onReset) onReset();
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        layout = _this$props4.layout,
        style = _this$props4.style,
        inline = _this$props4.inline,
        disabled = _this$props4.disabled,
        datum = _this$props4.datum,
        rules = _this$props4.rules,
        pending = _this$props4.pending;

    if (datum && rules && datum.rules !== rules) {
      datum.rules = rules;
    }

    var className = (0, _classnames.default)((0, _styles.formClass)('_', layout, (disabled || pending) && 'disabled', inline && 'inline'), this.props.className);
    return _react.default.createElement("form", {
      ref: this.bindElement,
      className: className,
      id: this.id,
      style: style,
      onReset: this.handleReset,
      onSubmit: this.handleSubmit
    }, this.props.children);
  };

  return Form;
}(_react.Component);

Form.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'disabled'), {
  datum: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  layout: _propTypes.default.string,
  pending: _propTypes.default.bool,
  onError: _propTypes.default.func,
  onReset: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  rules: _propTypes.default.object,
  scrollToError: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  setFormStatus: _propTypes.default.func,
  throttle: _propTypes.default.number
});
Form.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  scrollToError: false,
  throttle: 1000
});
var _default = Form;
exports.default = _default;